<template>
    <div class="main">
        <el-form
            ref="elForm"
            :inline="true"
            :model="formData"
            :rules="rules"
            size="medium"
            label-width="190px"
            v-loading="loading"
        >
            <el-row>
                <div class="tit" style="font-size:28px; font-weight:bold;">
                    企业入驻申请表
                </div>
            </el-row>
            <el-row>
                <div class="tit">基本信息</div>
            </el-row>
            <el-form-item label="园区地点" prop="baseSite">
                <el-select
                    v-model="formData.baseSite"
                    placeholder="请选择园区地点"
                >
                    <el-option
                        v-for="item in baseSiteData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="项目名称" prop="baseProjectName">
                <el-input
                    v-model="formData.baseProjectName"
                    type="textarea"
                    placeholder="100字以内"
                    maxlength="100"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="国家重点支持高新技术领域"
                prop="baseTechnosphere"
            >
                <el-select
                    v-model="formData.baseTechnosphere"
                    placeholder="请选择领域"
                >
                    <el-option
                        v-for="item in baseTechnosphereData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="团队成员数" prop="basePeopleCount">
                <el-input
                    v-model="formData.basePeopleCount"
                    placeholder="请输入团队成员数"
                    maxlength="10"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="项目领域描述" prop="baseDescribe">
                <el-input
                    v-model="formData.baseDescribe"
                    type="textarea"
                    placeholder="1024字以内"
                    maxlength="1024"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-row>
                <div class="tit">项目执行信息</div>
            </el-row>
            <el-form-item label="项目简介" prop="proSynopsis">
                <el-input
                    v-model="formData.proSynopsis"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                    placeholder="1024字以内"
                    maxlength="1024"
                ></el-input>
            </el-form-item>
            <el-form-item label="创新点" prop="proNewIdea">
                <el-input
                    v-model="formData.proNewIdea"
                    type="textarea"
                    placeholder="255字以内"
                    maxlength="255"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="难点" prop="proDifficult">
                <el-input
                    v-model="formData.proDifficult"
                    type="textarea"
                    placeholder="255字以内"
                    maxlength="255"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="6个月内分阶段预期成果（每三个月为一个阶段）"
                prop="proAnticipated"
            >
                <el-input
                    v-model="formData.proAnticipated"
                    type="textarea"
                    placeholder="1024字以内"
                    maxlength="1024"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="可行性分析" prop="proFeasibilityAnalysis">
                <el-input
                    v-model="formData.proFeasibilityAnalysis"
                    type="textarea"
                    placeholder="1024字以内"
                    maxlength="1024"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>

            <el-form-item label="团队分工及股权结构" prop="proTeam">
                <el-input
                    v-model="formData.proTeam"
                    type="textarea"
                    placeholder="1024字以内"
                    maxlength="1024"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="项目执行进度预计" prop="proExpected">
                <el-input
                    v-model="formData.proExpected"
                    type="textarea"
                    placeholder="1024字以内"
                    maxlength="1024"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-row>
                <div class="tit">孵化需求</div>
            </el-row>
            <el-form-item label="场地需求" prop="needSite">
                <el-select
                    v-model="formData.needSite"
                    placeholder="请选择场地需求"
                >
                    <el-option
                        v-for="item in needSiteData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创业指导" prop="needGuidance">
                <el-input
                    v-model="formData.needGuidance"
                    type="textarea"
                    placeholder="255字以内"
                    maxlength="255"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="投资需求" prop="needInvest">
                <el-input
                    v-model="formData.needInvest"
                    type="textarea"
                    placeholder="255字以内"
                    maxlength="255"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="政策需求" prop="needPolicy">
                <el-input
                    v-model="formData.needPolicy"
                    type="textarea"
                    placeholder="255字以内"
                    maxlength="255"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-form-item label="是否需要注册公司" prop="needIsCompany">
                <el-select
                    v-model="formData.needIsCompany"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in needIsCompanyData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="其他服务需求" prop="needOther">
                <el-input
                    v-model="formData.needOther"
                    type="textarea"
                    placeholder="255字以内"
                    maxlength="255"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    :style="{ width: '670px' }"
                ></el-input>
            </el-form-item>
            <el-row>
                <div class="tit">附件材料上传</div>
            </el-row>
            <el-row>
                <el-form-item label="负责人或主创团队简历" prop="fileResume">
                    <el-upload
                        class="avatar-uploader"
                        :action="fileUpload"
                        :show-file-list="false"
                        :on-success="createHandleAvatarSuccess('fileResume')"
                        :before-upload="beforeAvatarUpload"
                    >
                        <div class="pic-box">
                            <div v-if="formData.fileResume">
                                <img
                                    v-if="isIMG(formData.fileResume)"
                                    :src="
                                        formData.fileResume +
                                            '?x-oss-process=image/resize,m_pad,h_178,w_178'
                                    "
                                    class="avatar"
                                />
                                <div class="file-con" src v-else>已上传</div>
                            </div>
                            <i
                                v-else
                                class="el-icon-circle-plus-outline"
                                style="font-size: 26px;margin-top: 4px;"
                            ></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="项目BP" prop="fileBp">
                    <el-upload
                        class="avatar-uploader"
                        :action="fileUpload"
                        :show-file-list="false"
                        :on-success="createHandleAvatarSuccess('fileBp')"
                        :before-upload="beforeAvatarUpload"
                    >
                        <div class="pic-box">
                            <div v-if="formData.fileBp">
                                <img
                                    v-if="isIMG(formData.fileBp)"
                                    :src="
                                        formData.fileBp +
                                            '?x-oss-process=image/resize,m_pad,h_178,w_178'
                                    "
                                    class="avatar"
                                />
                                <div class="file-con" src v-else>已上传</div>
                            </div>
                            <i
                                v-else
                                class="el-icon-circle-plus-outline"
                                style="font-size: 26px;margin-top: 4px;"
                            ></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="项目PPT" prop="filePpt">
                    <el-upload
                        class="avatar-uploader"
                        :action="fileUpload"
                        :show-file-list="false"
                        :on-success="createHandleAvatarSuccess('filePpt')"
                        :before-upload="beforeAvatarUpload"
                    >
                        <div class="pic-box">
                            <div v-if="formData.filePpt">
                                <img
                                    v-if="isIMG(formData.filePpt)"
                                    :src="
                                        formData.filePpt +
                                            '?x-oss-process=image/resize,m_pad,h_178,w_178'
                                    "
                                    class="avatar"
                                />
                                <div class="file-con" src v-else>已上传</div>
                            </div>

                            <i
                                v-else
                                class="el-icon-circle-plus-outline"
                                style="font-size: 26px;margin-top: 4px;"
                            ></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-row>
            <el-row>
                <div class="tit">团队信息</div>
            </el-row>
            <div
                class="item-work"
                v-for="(item, index) in formData.teamMembersObj"
                :key="index"
            >
                <div v-if="index == 0">负责人信息</div>
                <div v-else>
                    其他成员{{ index }}
                    <el-button
                        style="margin-left: 10px"
                        v-if="formData.teamMembersObj.length > 2"
                        size="mini"
                        type="danger"
                        @click="clickDelWork(index)"
                        >删除</el-button
                    >
                </div>

                <el-form-item
                    label-width="111px"
                    label="姓名"
                    :prop="'teamMembersObj.' + index + '.name'"
                    :rules="{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur',
                    }"
                >
                    <el-input
                        v-model="item.name"
                        placeholder="20字以内"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="出生日期"
                    :prop="'teamMembersObj.' + index + '.birthday'"
                    :rules="{
                        required: true,
                        message: '请选择出生日期',
                        trigger: 'change',
                    }"
                >
                    <el-date-picker
                        type="date"
                        placeholder="请输入出生日期"
                        value-format="yyyy-MM-dd"
                        v-model="item.birthday"
                        style="width: 100%;"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="毕业/就读学校"
                    :prop="'teamMembersObj.' + index + '.graduateFrom'"
                    :rules="{
                        required: true,
                        message: '请输入毕业/就读学校',
                        trigger: 'blur',
                    }"
                >
                    <el-input
                        v-model="item.graduateFrom"
                        placeholder="20字以内"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="专业"
                    :prop="'teamMembersObj.' + index + '.major'"
                    :rules="{
                        required: true,
                        message: '请输入专业',
                        trigger: 'blur',
                    }"
                >
                    <el-input
                        v-model="item.major"
                        placeholder="20字以内"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="手机"
                    :prop="'teamMembersObj.' + index + '.mobile'"
                    :rules="{
                        required: true,
                        message: '请输入手机',
                        trigger: 'blur',
                    }"
                >
                    <el-input
                        v-model="item.mobile"
                        placeholder="请输入手机"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="Email"
                    :prop="'teamMembersObj.' + index + '.email'"
                    :rules="rules.email"
                >
                    <el-input
                        v-model="item.email"
                        placeholder="请输入Email"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="简历"
                    :prop="'teamMembersObj.' + index + '.resume'"
                    :rules="{
                        required: true,
                        message: '请输入简历',
                        trigger: 'blur',
                    }"
                >
                    <el-input
                        v-model="item.resume"
                        type="textarea"
                        placeholder="1024字以内"
                        maxlength="1024"
                        :autosize="{ minRows: 3, maxRows: 6 }"
                        :style="{ width: '620px' }"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-width="111px"
                    label="CV上传"
                    :prop="'teamMembersObj.' + index + '.cv'"
                >
                    <el-upload
                        class="avatar-uploader"
                        :action="fileUpload"
                        :show-file-list="false"
                        :on-success="
                            createHandleAvatarSuccess(
                                'teamMembersObj.' + index + '.cv',
                                true,
                                index,
                                'cv'
                            )
                        "
                        :before-upload="beforeAvatarUpload"
                    >
                        <div class="pic-box">
                            <div v-if="item.cv">
                                <img
                                    v-if="isIMG(item.cv)"
                                    :src="
                                        item.cv +
                                            '?x-oss-process=image/resize,m_pad,h_178,w_178'
                                    "
                                    class="avatar"
                                />
                                <div class="file-con" src v-else>已上传</div>
                            </div>
                            <i
                                v-else
                                class="el-icon-circle-plus-outline"
                                style="font-size: 26px;margin-top: 4px;"
                            ></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </div>
            <el-row>
                <el-button
                    style="margin: 0 80px 50px;"
                    size="mini"
                    type="primary"
                    @click="clickAddWork"
                    >添加其他成员</el-button
                >
            </el-row>
            <el-row style="text-align: center">
                <el-form-item size="large">
                    <el-button type="primary" @click="submitForm"
                        >提交</el-button
                    >
                    <el-button @click="resetForm">重置</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </div>
</template>
<script>
const defaultworkitem = {
    type: undefined, //   负责人, 其他成员
    name: undefined, //  姓名
    birthday: undefined, //   出生日期
    graduateFrom: undefined, //  毕业/就读学校
    major: undefined, //   专业(主修科目)
    mobile: undefined, //  手机
    email: undefined, //   Email
    resume: undefined, //    简历
    cv: undefined, //  CV上传
    type: "其他成员",
};
import { rap, fetch } from "@/utils/common.js";

let url = {
    get: "/fep/pc/ad/get",
    fileUpload: "/fep/file/adds",
    update: "/fep/pc/ad/update",
    add: "/fep/pc/workroomCompanyIn/add",
};
export default {
    components: {},
    props: [],
    data() {
        var checkNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入团队成员数"));
            }
            let num = parseInt(value);
            if (!num || num == 0) {
                callback(new Error("团队成员数必须为数字类型且大于0"));
            } else {
                callback();
            }
        };
        var checkEmail = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入邮箱"));
            }
            if (
                !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
                    value
                )
            ) {
                return callback(new Error("请输入正确格式的邮箱"));
            }
            return callback();
        };
        return {
            loading: false,
            fileUpload: url.fileUpload,
            formData: {
                baseSite: undefined,
                baseProjectName: undefined,
                baseTechnosphere: undefined,
                basePeopleCount: undefined,
                baseDescribe: undefined,
                proSynopsis: undefined,
                proNewIdea: undefined,
                proDifficult: undefined,
                proAnticipated: undefined,
                proFeasibilityAnalysis: undefined,
                proExpected: undefined,
                proTeam: undefined,
                needSite: undefined,
                needGuidance: undefined,
                needInvest: undefined,
                needPolicy: undefined,
                needIsCompany: undefined,
                needOther: undefined,
                fileResume: undefined,
                fileBp: undefined,
                filePpt: undefined,
                teamMembersObj: [
                    { ...defaultworkitem, type: "负责人" },
                    { ...defaultworkitem },
                ],
            },
            baseTechnosphereData: [
                { id: "电子信息技术", name: "电子信息技术" },
                { id: "生物与新医药技术", name: "生物与新医药技术" },
                { id: "航空航天技术", name: "航空航天技术" },
                { id: "新材料技术", name: "新材料技术" },
                { id: "高技术服务业", name: "高技术服务业" },
                { id: "新能源及节能技术", name: "新能源及节能技术" },
                { id: "资源与环境技术", name: "资源与环境技术" },
                { id: "高新技术改造传统产业", name: "高新技术改造传统产业" },
            ],
            baseSiteData: [
                {
                    id: "珠海左右创意园投资有限公司",
                    name: "珠海左右创意园投资有限公司",
                },
                {
                    id: "珠海市台港澳创新创业基地 ",
                    name: "珠海市台港澳创新创业基地 ",
                },
                {
                    id: "珠海市大华港澳青年创新创业服务中心",
                    name: " 珠海市大华港澳青年创新创业服务中心",
                },
            ],
            needSiteData: [
                { id: "开放式工位", name: "开放式工位" },
                { id: "40平方米以下", name: "40平方米以下" },
                { id: "40-100平方米", name: "40-100平方米" },
                { id: "100-200平方米", name: "100-200平方米" },
                { id: "200平方米以上", name: "200平方米以上" },
            ],
            needIsCompanyData: [
                { id: "是", name: "是" },
                { id: "否", name: "否" },
            ],
            rules: {
                baseSite: [
                    {
                        required: true,
                        message: "请输入园区地点",
                        trigger: "blur",
                    },
                ],
                baseProjectName: [
                    {
                        required: true,
                        message: "请输入项目名称",
                        trigger: "blur",
                    },
                ],
                baseTechnosphere: [
                    {
                        required: true,
                        message: "请选择国家重点支持高新技术领域",
                        trigger: "change",
                    },
                ],
                basePeopleCount: [
                    {
                        required: true,
                        validator: checkNum,
                        trigger: "blur",
                    },
                ],
                baseDescribe: [
                    {
                        required: true,
                        message: "请输入项目领域描述",
                        trigger: "blur",
                    },
                ],
                proSynopsis: [
                    {
                        required: true,
                        message: "请输入项目简介",
                        trigger: "blur",
                    },
                ],
                proNewIdea: [
                    {
                        required: true,
                        message: "请输入创新点",
                        trigger: "blur",
                    },
                ],
                proDifficult: [
                    {
                        required: true,
                        message: "请输入难点",
                        trigger: "blur",
                    },
                ],
                proAnticipated: [
                    {
                        required: true,
                        message:
                            "请输入6个月内分阶段预期成果（每三个月为一个阶段）",
                        trigger: "blur",
                    },
                ],
                proFeasibilityAnalysis: [
                    {
                        required: true,
                        message: "请输入可行性分析",
                        trigger: "blur",
                    },
                ],
                proExpected: [
                    {
                        required: true,
                        message: "请输入项目执行进度预计",
                        trigger: "blur",
                    },
                ],
                proTeam: [
                    {
                        required: true,
                        message: "请输入团队分工及股权结构",
                        trigger: "blur",
                    },
                ],
                needSite: [
                    {
                        required: true,
                        message: "请选择场地需求",
                        trigger: "change",
                    },
                ],
                needGuidance: [
                    {
                        required: true,
                        message: "请输入创业指导",
                        trigger: "blur",
                    },
                ],
                needInvest: [
                    {
                        required: true,
                        message: "请输入投资需求",
                        trigger: "blur",
                    },
                ],
                needPolicy: [
                    {
                        required: true,
                        message: "请输入政策需求",
                        trigger: "blur",
                    },
                ],
                needIsCompany: [
                    {
                        required: true,
                        message: "请输入是否需要注册公司",
                        trigger: "change",
                    },
                ],
                needOther: [
                    {
                        required: true,
                        message: "请输入其他服务需求",
                        trigger: "blur",
                    },
                ],
                fileResume: [
                    {
                        required: true,
                        message: "请上传负责人或主创团队简历",
                        trigger: "blur",
                    },
                ],
                fileBp: [
                    {
                        required: true,
                        message: "请上传项目BP",
                        trigger: "blur",
                    },
                ],
                filePpt: [
                    {
                        required: true,
                        message: "请上传项目PPT",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        validator: checkEmail,
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        submitForm() {
            this.$refs["elForm"].validate((valid) => {
                if (!valid) return;
                // TODO 提交表单

                let data = {
                    ...this.formData,
                };
                this.loading = true;
                fetch(url.add, data).then(
                    (res) => {
                        this.loading = false;
                        if (res.status === 200) {
                            // this.$message({
                            //     message: '提交成功',
                            //     type: "success",
                            // });
                            this.$router.replace("/enterdone");
                        }
                    },
                    (res) => {
                        this.loading = false;
                        this.$message.error(res.message);
                    }
                );
            });
        },
        resetForm() {
            this.$refs["elForm"].resetFields();
        },

        // 添加作业
        clickAddWork() {
            this.formData.teamMembersObj.push({ ...defaultworkitem });
        },

        clickDelWork(index) {
            this.formData.teamMembersObj.splice(index, 1);
        },
        createHandleAvatarSuccess(fileName, isSpecal, i, key) {
            return (res, file) => {
                // console.log(res, file)
                if (res.status === 200) {
                    this.$message({
                        message: res.message,
                        type: "success",
                    });
                    // debugger
                    if (isSpecal) {
                        this.formData.teamMembersObj[i][key] =
                            res.data.list[0].url;
                    } else {
                        this.formData[fileName] = res.data.list[0].url;
                    }
                }
            };
        },
        handleAvatarSuccess(res, file) {
            // console.log(res, file)
            if (res.status === 200) {
                this.$message({
                    message: res.message,
                    type: "success",
                });
                this.formData.image = res.data.list[0].id;
            }
            this.formData.imageUrl = URL.createObjectURL(file.raw);
        },

        beforeAvatarUpload(file) {
            return true;
            // const isJPG =
            //     file.type === "image/jpeg" ||
            //     file.type === "image/bmp" ||
            //     file.type === "image/x-ms-bmp" ||
            //     file.type === "image/vnd.wap.wbmp" ||
            //     file.type === "image/png";
            // const isLt2M = true; //file.size / 1024 / 1024 < 2
            // if (!isJPG) {
            //     this.$message.error("上传图片只能是JPG/\BMP/\PNG格式!");
            // }
            // if (!isLt2M) {
            //     this.$message.error("上传图片大小不能超过 2MB!");
            // }
            // return isJPG && isLt2M;
        },

        isIMG(url) {
            const isJPG =
                url.indexOf(".jpeg") > -1 ||
                url.indexOf(".jpg") > -1 ||
                url.indexOf(".bmp") > -1 ||
                url.indexOf(".png") > -1;

            return isJPG;
        },
    },
};
</script>
<style>
#app {
    overflow: auto !important;
}
.el-form-item__label {
    color: #888;
    padding-right: 8px;
    white-space: normal !important;
}
.main {
    width: 1000px;
    padding: 20px;
    margin: 30px auto 30px;
    border: 1px solid #f7f7f7;
    background: #fcfcfc;
    box-shadow: rgb(230, 240, 240, 0.6) 5px 2px 40px 5px;
}
.tit {
    margin-top: 30px;
    text-align: center;
    line-height: 25px;
    font-size: 22px;
}
.item-work {
    border: 1px solid #eaeaea;
    margin: 30px auto;
    width: 800px;
    padding: 20px;
    box-shadow: rgb(230, 240, 240, 0.5) 5px 2px 40px 5px;
    border-radius: 5px;
}
.file-con {
    color: #000000;
}
.pic-box {
    width: 300px;
    text-align: left;
}
</style>
